export default __webpack_public_path__ + "static/media/ico_cancel.ba71eee2.svg";